import {
  authActions,
  AuthActions,
  AuthScope,
  AuthState,
  ReducerChain,
  UserData,
  withScope,
} from "@gamedev-web/gamedev-sdk-core";

const initialState: UserData = {
  isFetched: false,
  userInfo: undefined,
  gdasProfile: undefined,
  gdasSellers: undefined,
  gdasClaims: undefined,
};

export const updateUser = (
  state: AuthState,
  action: ReturnType<typeof authActions.updateUser>
): AuthState => ({
  ...state,
  isFetched: true,
  userInfo: action.userInfo,
});

export const updateGdasProfile = (
  state: AuthState,
  action: ReturnType<typeof authActions.updateGdasProfile>
): AuthState => ({
  ...state,
  gdasProfile: action.gdasProfile,
});

export const updateGdasSellers = (
  state: AuthState,
  action: ReturnType<typeof authActions.updateGdasSellers>
): AuthState => ({
  ...state,
  gdasSellers: action.gdasSellers,
});

export const updateGdasClaims = (
  state: AuthState,
  action: ReturnType<typeof authActions.updateGdasClaims>
): AuthState => ({
  ...state,
  gdasClaims: action.gdasClaims,
});

export const setActiveTenant = (
  state: AuthState,
  action: ReturnType<typeof authActions.setActiveTenant>
): AuthState => {
  if (!state.gdasProfile) {
    return state;
  }
  return {
    ...state,
    gdasProfile: {
      ...state.gdasProfile,
      tenants: {
        ...state.gdasProfile.tenants,
        activeTenantId: action.tenantId,
      },
    },
  };
};

const authReducerWithoutScope = new ReducerChain<AuthState>(initialState)
  .on(AuthActions.UPDATE_USER, updateUser)
  .on(AuthActions.UPDATE_GDAS_PROFILE, updateGdasProfile)
  .on(AuthActions.UPDATE_GDAS_SELLERS, updateGdasSellers)
  .on(AuthActions.UPDATE_GDAS_CLAIMS, updateGdasClaims)
  .on(AuthActions.SET_ACTIVE_TENANT, setActiveTenant)
  .build();

export const authReducer = withScope(AuthScope, authReducerWithoutScope);
